import axios from 'axios';
import { normalizeKycResponse } from './taskApi';

const API_ORIGIN = 'https://dhanwalle.in';
const TASK_API = `${API_ORIGIN}/Api/TaskApi`;
const LOAN_BACKEND = `${API_ORIGIN}/loan_backend`;
const TASK_API_KEY = 'gy577%&Ffe';

const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

function cleanText(value) {
  return String(value).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
}

function readText(value, depth = 0) {
  if (value == null || value === false || depth > 3) return '';
  if (typeof value === 'string' || typeof value === 'number') return cleanText(value);
  if (Array.isArray(value)) {
    return value.map((item) => readText(item, depth + 1)).filter(Boolean).join(' ').trim();
  }
  if (typeof value !== 'object') return '';
  const keys = [
    'responseMessage',
    'response_message',
    'message',
    'Message',
    'msg',
    'error',
    'error_message',
    'errorMessage',
    'reason',
    'remarks',
    'description',
  ];
  for (const key of keys) {
    const text = readText(value[key], depth + 1);
    if (text) return text;
  }
  return '';
}

export function apiText(payload) {
  if (payload == null) return '';
  const direct = readText(payload);
  if (direct) return direct;
  if (typeof payload !== 'object') return '';
  return (
    readText(payload.api_response) ||
    readText(payload.data) ||
    readText(payload.result) ||
    readText(payload.raw) ||
    ''
  );
}

/** Clear reason when government PAN verify does not succeed. */
export function panVerifyFailMessage(normalized) {
  const raw = normalized?.raw && typeof normalized.raw === 'object' ? normalized.raw : {};
  const data = normalized?.data && typeof normalized.data === 'object' ? normalized.data : {};
  const code = String(
    normalized?.responseCode || raw.responseCode || raw.response_code || data.responseCode || ''
  ).toUpperCase();
  const status = String(
    data.status || data.Status || data.panStatus || data.pan_status || raw.status || ''
  ).toUpperCase();
  const msg = apiText(normalized) || apiText(raw) || apiText(data);

  if (
    code === 'ENI004' ||
    /no information found|pan not found|does not exist|not found in any database/i.test(msg)
  ) {
    return msg || 'No Information Found.';
  }
  if (status === 'INVALID' || /invalid pan/i.test(msg)) {
    return msg || 'This PAN is invalid. Please check the number and try again.';
  }
  if (msg) return msg;

  if (typeof normalized?.raw === 'string') {
    const text = apiText(normalized.raw).slice(0, 180);
    if (text) return text;
  }

  const detail = [
    code && `code ${code}`,
    status && `status ${status}`,
  ].filter(Boolean).join(', ');
  if (detail) return `PAN verification failed (${detail}).`;
  return 'PAN verification failed. The server did not return a reason.';
}

export async function getStates() {
  const resp = await axios.get(`${TASK_API}/getState`, {
    headers: { Accept: 'application/json' },
    validateStatus: () => true,
  });
  return resp.data;
}

export async function getCities(stateId) {
  const resp = await axios.post(
    `${TASK_API}/getCity`,
    { state_id: String(stateId) },
    { headers: jsonHeaders, validateStatus: () => true }
  );
  return resp.data;
}

export async function getPincodesByCityId(cityId) {
  const resp = await axios.post(
    `${TASK_API}/getPincodeByCityId`,
    { city_id: String(cityId) },
    { headers: jsonHeaders, validateStatus: () => true }
  );
  return resp.data;
}

export async function apiSendOtp(mobile) {
  const body = new URLSearchParams();
  body.append('mobile', mobile);
  return axios.post(`${TASK_API}/sendOtp`, body, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-API-KEY': TASK_API_KEY,
    },
    validateStatus: () => true,
  });
}

export async function apiVerifyOtp(mobile, otp) {
  const body = new URLSearchParams();
  body.append('mobile', mobile);
  body.append('otp', otp);
  return axios.post(`${TASK_API}/verifyOtp`, body, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-API-KEY': TASK_API_KEY,
    },
    validateStatus: () => true,
  });
}

/** PAN 1 — government verify */
export async function verifyPan(pan) {
  const resp = await axios.post(
    `${LOAN_BACKEND}/verifyPan.php`,
    { pan },
    { headers: jsonHeaders, validateStatus: () => true }
  );
  return normalizeKycResponse(resp.data);
}

/** PAN 2 — blacklist */
export async function checkPanBlacklist(pan) {
  const resp = await axios.get(`${TASK_API}/checkGetCustomerbyPanBlacklist`, {
    params: { pancard: pan },
    headers: { Accept: 'application/json' },
    validateStatus: () => true,
  });
  return resp.data || {};
}

/** PAN 3 — existing customer / lead status */
export async function checkExistingCustomerByPan(pan) {
  const resp = await axios.get(`${TASK_API}/checkGetCustomerbyPan`, {
    params: { pancard: pan },
    headers: { Accept: 'application/json' },
    validateStatus: () => true,
  });
  return resp.data || {};
}

export async function saveLendingPage(payload) {
  const resp = await axios.post(`${TASK_API}/saveLendingPageNew`, payload, {
    headers: jsonHeaders,
    validateStatus: () => true,
  });
  return resp.data || {};
}
